





























































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import type { Ref } from '@vue/composition-api';
import { useMutation, useQuery } from '@vue/apollo-composable';

import type { ID } from '@/types';
import type { Area } from '@/useDeliveryAreaCode';
import CommonProvinceSelector from '@/components/LocationAddress/CommonProvinceSelector.vue';
import Loading from '@/components/Loading.vue';
import DistrictSelector from './DistrictSelector.vue';

import getDistricts from '@/gql/thaiLocation/thailandDistricts.gql';
import findAreaCodes from '@/gql/areaCode/findAreaCodes.gql';

const RoutingForm = defineComponent({
  components: {
    Loading,
    CommonProvinceSelector,
    DistrictSelector,
  },
  props: {
    value: {
      default: () => ({}),
    },
    subdistrictLists: { default: () => [] },
  },
  setup(props, { emit }) {
    const search = reactive({
      zipcode: '',
      province: '',
    });

    const { result: districtResult, loading: districtLoading } = useQuery(
      getDistricts,
      () => ({
        provinceId: search.province !== '' ? search.province : undefined,
        zipcode: search.zipcode !== '' ? search.zipcode : undefined,
        filterSubdistrict: search.zipcode !== '' ? {
          column: 'ZIP_CODE',
          value: search.zipcode,
        } : undefined,
      }),
      () => ({
        enabled: search.zipcode !== '' || search.province !== '',
        skip: () => search.zipcode === '' && search.province === '',
      }),
    );

    const districtsBundle = computed(() => districtResult.value?.districts || []);

    const internalValue: Ref<{ district: boolean; subdistricts: ID[] }[]> = ref([]);

    function cancel() {
      internalValue.value = [];
      emit('cancel');
    }

    function submit() {
      // eslint-disable-next-line
      const result = [...internalValue.value.map((internalVal, i) => {
        if (internalVal && internalVal.district) {
          return {
            province: districtsBundle.value[i].province,
            districts: {
              id: districtsBundle.value[i].id,
              nameInThai: districtsBundle.value[i].nameInThai,
              subdistricts: districtsBundle.value[i]?.subdistricts.filter((subdist: any) => internalValue.value[i].subdistricts.indexOf(subdist.id) > -1),
            },
          };
        }
      }).filter((internalVal) => internalVal !== undefined && internalVal.districts.subdistricts.length > 0)];
      internalValue.value = [];
      emit('submit', result);
    }

    const findAreaCodesPayload = computed(() => {
      const result: { [key: string]: any[] } = {
        provinceIds: [],
        districtIds: [],
        subdistrictIds: [],
      };
      internalValue.value.forEach((internalVal, i) => {
        if (internalVal && internalVal.district) {
          internalVal.subdistricts.forEach((subdistrictId) => {
            result.provinceIds.push(districtsBundle.value[i].province.id);
            result.districtIds.push(districtsBundle.value[i].id);
            result.subdistrictIds.push(subdistrictId);
          });
        }
      });

      return result;
    });
    const findAreaCodesMutation = useMutation(findAreaCodes, () => ({
      variables: findAreaCodesPayload.value,
    }));
    const findAreaCodesResponse = ref([]);
    findAreaCodesMutation.onDone((response) => {
      if (response) {
        districtLoading.value = false;
        findAreaCodesResponse.value = response.data.findAreaCodes.filter((result: any) => result.area !== null);
      }

      if (findAreaCodesResponse.value.length === 0) {
        submit();
      }
    });
    const duplicateSubdistrict = computed(() => findAreaCodesResponse.value.map((result: any) => result.subdistrictId));
    function pendingSubmit() {
      districtLoading.value = true;
      findAreaCodesMutation.mutate();
    }

    return {
      search,
      internalValue,
      districtsBundle,
      districtLoading,

      findAreaCodesPayload,
      findAreaCodesResponse,
      duplicateSubdistrict,

      cancel,
      pendingSubmit,
      submit,
    };
  },
});

export default RoutingForm;
